/* eslint-disable */
import React from 'react'
import { hydrate } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import fetch from 'isomorphic-fetch'

import App from './app'
import makeClient from './urql/client'
import { getCookie, getCookies } from '~/utils/cookies'
import { env } from './server/helpers/env'
import { loadableReady } from '@loadable/component'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { emotionCacheKey } from './server/helpers/env'

const [client] = makeClient({ isServer: false, fetch, uscd: getCookie('uscd') })

const cache = createCache({ key: emotionCacheKey })

loadableReady(() => {
  const root = document.getElementById('app')
  if (!root) throw new Error('ENOROOT')

  hydrate(
    <CacheProvider value={cache}>
      <BrowserRouter>
        <App
          client={client}
          comparisonId={window.__comparisonId__}
          cleanQueryString={window.__cleanQueryString__}
          isPersonalisedResults={window.__isPersonalisedResults__}
          cookies={getCookies()}
          device={window.__device__}
          isMobileApp={window.__isMobileApp__}
          env={env}
          experiences={window.__experiences}
          evCore={window.__evCore__?.state}
          theme={window.__theme__}
          trafficSource={window.__trafficSource__}
        />
      </BrowserRouter>
    </CacheProvider>,
    root
  )
})

if (module.hot) {
  module.hot.accept()
}
